module.exports = __webpack_public_path__ + "img/3_83.3c7c9e47.png";